import { i18n } from "services/i18nService";
import { formatNameLinkField, formatSync } from "services/utility/formatting";

export const EMPTY_RECORD = { dateAdded: null, message: null };

export const columnInfo = [
  {
    name: "name",
    fixed: true,
    heading: i18n("columns.Name"),
    formatFunc: formatNameLinkField,
    defaultSort: true,
    linkField: true,
  },
  {
    name: "sync",
    fixed: true,
    fixedRightOfAction: true,
    heading: i18n("columns.Sync"),
    formatFunc: formatSync,
    default: true,
  },
];

const columnArray = Object.entries(columnInfo);
const defaultColumnInfo = columnArray.filter((col) => col[1].required);
export const defaultColumns = defaultColumnInfo.map((col) => col[0]);

export const LINE_ACTIONS = ["delete", "sync"];
export const BATCH_ACTIONS = ["delete", "sync"];
